import {v4 as uuid } from 'uuid';

function updateTouched (keys) {
    if (!this.touchedFields) {
        this.touchedFields = {};
    }
    this.uikeys = keys.map((key) => {
        this.touchedFields[key] = true;
        return key;
    });
   
    this.observed.touchedFields = uuid();
}

export default updateTouched;
